import Phaser, { Scene } from 'phaser'
import { SCENE_PARAMETERS } from './../constants/game-constants'
import { seconds2StringFormat } from './../utils/functions'
import {
  ENVIRONMENT_ELEMENTS_PUBERTAD,
  SINTOMAS_ELEMENTS,
  SPRITE_ASSETS,
} from './../constants/assets-constants'

export default class Gamepubertad extends Scene {
  constructor() {
    super({
      key: 'pubertad',
      type: Phaser.AUTO,
      physics: {
        default: 'arcade',
        arcade: {
          debug: false,
          gravity: { x: 0, y: SCENE_PARAMETERS.PUBERTAD.GRAVITY },
        },
      },
    })
  }

  // PREPARE data and default configs
  init(props) {
    this.props = props
    this.data.set('points', 0)
    this.data.set('time', SCENE_PARAMETERS.PUBERTAD.TIME_LIMIT)
    this.data.set('isDownPress', false)
    this.data.set('isJumpPress', false)
  }

  // LOAD assets
  preload() {
    Object.keys(ENVIRONMENT_ELEMENTS_PUBERTAD).map(elementKey => {
      this.load.image(elementKey, ENVIRONMENT_ELEMENTS_PUBERTAD[elementKey])
    })
    Object.keys(SINTOMAS_ELEMENTS).map(elementKey => {
      this.load.image(elementKey, SINTOMAS_ELEMENTS[elementKey])
    })

    this.load.spritesheet('personajeSprite', SPRITE_ASSETS.personajeSprite, {
      frameWidth: 250,
      frameHeight: 330,
    })
  }

  // ADD assets
  create() {
    this.addUIElements()
    this.addLives()
    this.addMoon()
    this.addPersonaje()
    this.addInputPlay()
  }

  // RELOADS data on frames changes
  update() {
    if (this.lives.length < 1 || this.data.list.time < 1) {
      this.scene.stop()
      this.props.endScene({
        name: 'pubertad',
        points: this.data.list.points,
      })
      return
    }
    const CURRENT_TIME = this.data.list.time
    this.ui_clock_label.setText(seconds2StringFormat(CURRENT_TIME))
    this.ui_points_label.setText(this.data.list.points)
    // this.data.set(
    //   "points",
    //   SCENE_PARAMETERS.PUBERTAD.TIME_LIMIT - CURRENT_TIME
    // )

    if (!this.physics.world.isPaused)
      this.moon.rotation =
        this.moon.rotation + SCENE_PARAMETERS.PUBERTAD.MOON_ROTARION
  }

  addInputPlay() {
    this.physics.pause()
    let btnPlay = this.add
      .image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "play")
      .setInteractive()
      .setScale(this.props.isMobile ? 0.45 : 1)
    btnPlay.on(
      "pointerdown",
      () => {
        if (sessionStorage.getItem("F_DESAFIO_GAME_MODAL_IS_OPEN") === "true")
          return
        this.addInputs()
        this.addEmojis()
        this.addEventTimer()
        this.personaje.anims.play("jump")
        this.physics.resume()
        btnPlay.destroy()
      },
      this,
    )
  }

  addUIElements() {
    let TIMER_POSITION = this.props.isMobile
      ? {
        X: this.sys.canvas.width / 2,
        Y: 30,
      }
      : {
        X: 140,
        Y: 20,
      }

    const [ui_clock_text, ui_clock_icon, ui_clock_label] = this.addUIElement(
      TIMER_POSITION.X,
      TIMER_POSITION.Y,
      'TIEMPO',
      'm_clock',
      seconds2StringFormat(this.data.list.time),
    )

    this.ui_clock_text = ui_clock_text
    this.ui_clock_icon = ui_clock_icon
    this.ui_clock_label = ui_clock_label

    let POINTS_POSITION = this.props.isMobile
      ? {
        X: this.sys.canvas.width / 2 + 110,
        Y: 30,
      }
      : {
        X: this.sys.canvas.width - 10,
        Y: 20,
      }
    const [ui_points_text, ui_points_icon, ui_points_label] = this.addUIElement(
      POINTS_POSITION.X,
      POINTS_POSITION.Y,
      'PUNTOS',
      'm_star',
      this.data.list.points,
    )

    this.ui_points_text = ui_points_text
    this.ui_points_icon = ui_points_icon
    this.ui_points_label = ui_points_label

    this.e_ui_box = this.add.graphics().fillStyle(0xffffff, 0.20)
    if (this.props.isMobile) {
      this.e_ui_box.fillRect(0, 120, this.sys.canvas.width, 80, 11)
    } else {
      const UI_BOX_WIDTH = this.sys.canvas.width * 0.6
      this.e_ui_box.fillRoundedRect(
        this.sys.canvas.width / 2 - UI_BOX_WIDTH / 2,
        5,
        UI_BOX_WIDTH,
        108,
        11,
      )
    }
  }

  addLives() {
    this.lives = []
    for (let index = 0; index < SCENE_PARAMETERS.PUBERTAD.LIVES; index++) {
      this.lives.push(
        this.add
          .image(
            this.sys.canvas.width / 2 - 100 + index * 100,
            this.props.isMobile ? 125 : 15,
            'lifeIcon',
          )
          .setOrigin(0.5, -0.1)
          .setScale(this.props.isMobile ? 0.8 : 1),
      )
    }
  }

  addMoon() {
    // TODO: add physics moon
    this.moon = this.physics.add
      .staticImage()
      .setTexture('planetaCircular')
      .setOrigin(0.5, 0.5)
      .setScale(0.8)
    const MOON_WIDTH_SCALE = this.moon.width * this.moon.scale
    this.moon
      .setPosition(
        this.sys.canvas.width / 2 +
        (this.props.isMobile ? -(this.sys.canvas.width * 0.3) : 0),
        this.sys.canvas.height * 0.8 + MOON_WIDTH_SCALE / 2,
      )
      .refreshBody()

    this.moon
      .setCircle(MOON_WIDTH_SCALE * 0.5)
      .setOffset(0, MOON_WIDTH_SCALE * 0.021)
  }

  addPersonaje() {
    this.PERSONAJE_BODY_WIDTH_FACTOR =
      SCENE_PARAMETERS.PUBERTAD.PERSONAJE_BODY_WIDTH_FACTOR +
      (this.props.isMobile ? -0.15 : 0)

    this.personaje = this.physics.add
      .sprite(
        this.sys.canvas.width / 2 +
        (this.props.isMobile ? -(this.sys.canvas.width * 0.3) : 0),
        this.sys.canvas.height * 0.7,
        'personajeSprite',
      )
      .setScale(0.55)
      .setOrigin(0.5, 1)
      .refreshBody()
    this.personaje
      .setBodySize(
        this.personaje.width * this.PERSONAJE_BODY_WIDTH_FACTOR,
        this.personaje.height * 0.9,
      )
      .refreshBody()
    // Animations
    this.anims.create({
      key: 'run',
      frames: this.anims.generateFrameNumbers('personajeSprite', {
        start: 0,
        end: 5,
      }),
      frameRate: 10,
      repeat: -1,
    })
    this.anims.create({
      key: 'jump',
      frames: this.anims.generateFrameNumbers('personajeSprite', {
        start: 6,
        end: 10,
      }),
      frameRate: 5,
      repeat: 0,
    })
    this.personaje.on(
      'animationcomplete',
      () => {
        this.personaje.anims.play('run')
      },
      this,
    )

    this.physics.add.collider(
      this.personaje,
      this.moon,
      (_personaje, _moon) => {
        if (this.data.list.isDownPress && this.data.list.isJumpPress) return
        if (this.data.list.isJumpPress) {
          _personaje.setVelocityY(
            SCENE_PARAMETERS.PUBERTAD.PERSONAJE_JUMP_VELOCITY_Y,
          )
          _personaje.anims.play('jump', true)
        }
        if (this.data.list.isDownPress) {
          _personaje
            .setBodySize(
              _personaje.width * this.PERSONAJE_BODY_WIDTH_FACTOR,
              _personaje.height * 0.6,
            )
            .refreshBody()
        } else {
          _personaje
            .setBodySize(
              _personaje.width * this.PERSONAJE_BODY_WIDTH_FACTOR,
              _personaje.height * 0.9,
            )
            .refreshBody()
        }
      },
      null,
      this,
    )
  }

  addInputs() {
    const jumpEvent = () => {
      this.data.set('isJumpPress', true)
    }
    const jumpEventOut = () => {
      this.data.set('isJumpPress', false)
    }
    const downEvent = () => {
      this.data.set('isDownPress', true)
    }
    const downEventOut = () => {
      this.data.set('isDownPress', false)
    }
    if (this.props.isMobile) {
      // TOUCH BTN INPUT
      const BTN_MARGIN_HORIZONTAL = 50
      const BTN_MARGIN_VERTICAL = this.sys.canvas.height - 250
      this.inputBtnUp = this.add
        .sprite(BTN_MARGIN_HORIZONTAL, BTN_MARGIN_VERTICAL, 'btnArrow')
        .setInteractive()
        .setRotation((0 * Math.PI) / 180)
        .setScale(0.7)

      this.inputBtnDown = this.add
        .image(BTN_MARGIN_HORIZONTAL, BTN_MARGIN_VERTICAL + 100, 'btnArrow')
        .setInteractive()
        .setRotation((180 * Math.PI) / 180)
        .setScale(0.7)
      this.inputBtnUp.on('pointerdown', jumpEvent, this)
      this.inputBtnUp.on('pointerout', jumpEventOut, this)
      this.inputBtnUp.on('pointerup', jumpEventOut, this)
      this.inputBtnDown.on('pointerdown', downEvent, this)
      this.inputBtnDown.on('pointerout', downEventOut, this)
      this.inputBtnDown.on('pointerup', downEventOut, this)
    }

    this.inputKeys = this.input.keyboard.createCursorKeys()
    this.inputKeys.up.on('down', jumpEvent, this)
    this.inputKeys.up.on('up', jumpEventOut, this)
    this.inputKeys.down.on('down', downEvent, this)
    this.inputKeys.down.on('up', downEventOut, this)
  }

  addEmojis() {
    this.emojis_group = this.physics.add
      .staticGroup({
        key: 'group_emoji',
      })
      .setVisible(false)

    if (!this.props.isMobile) this.addEmoji()

    this.e_timerEmojiEvent = this.time.addEvent({
      delay: SCENE_PARAMETERS.PUBERTAD.EMOJI_ADD_DELAY,
      callback: this.addEmoji,
      callbackScope: this,
      loop: true,
    })
  }

  addEmoji() {
    const EMOJI_RENDER_DISTANCE_Y = [
      this.sys.canvas.height * 0.8 - 10,
      this.sys.canvas.height * 0.8 - 150,
    ]
    let emojiElement = this.physics.add
      .image(
        this.sys.canvas.width + 0,
        Phaser.Math.RND.pick(EMOJI_RENDER_DISTANCE_Y),
        Phaser.Math.RND.pick(Object.keys(SINTOMAS_ELEMENTS)),
      )
      .setOrigin(0.5, 0.5)
      .setScale(0.7)
      .setVelocityX(
        SCENE_PARAMETERS.PUBERTAD.EMOJI_VELOCITY_X *
        (this.props.isMobile ? 0.85 : 1),
      )
    emojiElement.body.setAllowGravity(false)
    emojiElement.setCircle(emojiElement.width / 2)

    this.physics.add.overlap(
      this.personaje,
      emojiElement,
      (_personaje, _emoji) => {
        if (_emoji.texture.key === 'bonus') {


          this.addPopUpPointsBonus(_emoji)
          this.setPoints(2)
          _emoji.destroy()
          return

        }
        if (this.lives.length < 1) return
        this.lives[this.lives.length - 1].setTexture('lifeIconDisabled')
        this.lives.pop()
        _emoji.destroy()
      },
    )
    this.emojis_group.add(emojiElement)
    console.log('emoji')

    this.setPoints(1)

  }

  addEventTimer() {
    this.e_timerEvent = this.time.addEvent({
      delay: 1000,
      callback: this.decrementTimer,
      callbackScope: this,
      loop: true,
    })
  }

  // Functions

  decrementTimer() {
    const currentTime = this.data.list.time
    if (currentTime > 0) {
      this.data.set('time', currentTime - 1)
    } else {
      this.data.set('time', 0)
    }
  }

  addUIElement(
    _X = 0,
    _Y = 0,
    _TEXT = '----',
    _ICON = 'm_clock',
    _INITIAL_VALUE = '-- --',
  ) {
    const ui_text = this.add
      .text(
        this.props.isMobile ? _X : _X,
        this.props.isMobile ? _Y : _Y,
        _TEXT,
        {
          fontFamily: 'BwModelica-Medium',
          color: '#FFFFFF',
          fontSize: this.props.isMobile ? '16px' : '22px',
          align: 'center',
        },
      )
      .setOrigin(1, 0)
      .setDepth(5)

    const ui_icon = this.add
      .image(ui_text.x - ui_text.width - 5, ui_text.y, _ICON)
      .setOrigin(1, 0.1)
      .setScale(this.props.isMobile ? 0.7 : 1)
      .setDepth(5)

    const ui_data_label = this.add
      .text(
        this.props.isMobile
          ? _X - ui_text.width / 2 - 10
          : _X - ui_text.width / 2,
        this.props.isMobile ? _Y + 15 : _Y + 25,
        _INITIAL_VALUE,
        {
          fontFamily: 'BwModelica-Bold',
          color: '#FFFFFF',
          fontSize: this.props.isMobile ? '28px' : '35px',
          align: 'center',
        },
      )
      .setOrigin(0.5, 0)
      .setDepth(5)

    return [ui_text, ui_icon, ui_data_label]
  }


  setPoints(operator) {
    let newPoinst =
      this.data.list.points + SCENE_PARAMETERS.UTERO.POINTS_TO_ACTION * operator
    this.data.set('points', newPoinst < 0 ? 0 : newPoinst)
  }

  addPopUpPointsBonus(position) {
    const POP_UP_POSITION = {
      X: position.body.x,
      Y: position.body.y,
    }
    let points = this.add
      .image(POP_UP_POSITION.X, POP_UP_POSITION.Y, 'bonusPoints')
      .setScale(0.8)
      .setDepth(4)
    this.add.tween({
      targets: points,
      alpha: { from: 1, to: 0 },
      ease: 'Linear',
      duration: 500,
      repeat: 0, // -1: infinity
      yoyo: false,
    })
    setTimeout(() => {
      try {
        points.destroy()
      } catch (error) {
        console.log(error)
      }
    }, 1000)
  }

}

